import React, { useState } from "react";
import { Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router";
import { activateMenu } from "redux/actions";
import { useAppDispatch } from "redux/store";
import { setNagarType } from "redux/actions";

type Props = {
    id:number;
    nagar_khanda_name: string;
    gramas_formed: number;
    samithi_formed :number;
    total_basti_count:number;
    total_gramas_count:number;
    total_gramas_formed:number;
    total_samithi_formed:number;
    total_basti :number;
    nagar_type:number;
    total_gramas :number;
};
export const NagarSthayiReportCard: React.FC<Props> = ({ id,  total_basti_count,total_samithi_formed,total_gramas_count, total_gramas_formed,nagar_type,nagar_khanda_name,gramas_formed,samithi_formed,total_basti ,total_gramas }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

let jillaName=localStorage.getItem('zilla_name')

    return (
        <Col md={4} xl={3} xs={6} className="mb-4" >
                 <Card className=" shadow h-100 py-2.5" style={{ borderLeft: "5px solid #fd803a"}}>            
                           <Card.Body style={{padding :"2rem"}}>

                    <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                            <div className="text-xl font-weight-bold  text-uppercase mb-1" style={{color:"#fd803a"}}>
                                {jillaName !=  "null"  && 
                                <p>{jillaName}</p>} </div>
                            <div className=" mb-0 font-weight-bold text-gray-800"></div>
                        </div>
                    <div className=" mb-0.4 font-weight-bold text-gray-800">
                            {/* <i className="fas fa-clipboard-list fa-2x text-gray-300"></i> */}
                            <p>{total_samithi_formed}  Over  / {total_basti_count}  Total  Basthis</p>
                        </div>
                        <div className=" mb-0 font-weight-bold text-gray-800">
                            {/* <i className="fas fa-clipboard-list fa-2x text-gray-300"></i> */}
                            <p>{total_gramas_formed} Over  /  {total_gramas_count} Total Villages</p>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};

